import { CircularProgress, TextField } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { debounce } from 'lodash';
import { useContext, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { adminUpdateBooking, getAllUsers } from '../../../services/apiService';
import { getFullName } from '../../../utils';
import { CustomContext } from '../page';
import UserDetails from '../_components/UserDetails';
import { BOOKING_STAGES } from '../../../constants';

export default function ReplaceCoach({ booking, refreshData }) {
  const [coachOptions, setCoachOptions] = useState(null);
  const [selectedCoach, setSelectedCoach] = useState(null);
  const [input, setInput] = useState('');
  const [isQuerying, setIsQuerying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { setSelectedAction } = useContext(CustomContext);

  const handleSubmit = async (e) => {
    setIsLoading(true);
    try {
      await adminUpdateBooking({
        id: booking.id,
        coachId: null,
        stage: BOOKING_STAGES.TIME_SLOTS_ADDED.value,
        exclusiveForCoaches: [selectedCoach.id],
      });
      setSelectedAction(null);
      toast.success('Assigned coach');
      refreshData();
    } catch (err) {
      console.error(err);
      toast.error('Failed!');
    }
    setIsLoading(false);
  };

  const handleQuery = async (query) => {
    setIsQuerying(true);
    try {
      setCoachOptions(null);
      const response = await getAllUsers({ query, limit: 50 });
      if (response.users?.length) setCoachOptions(response.users);
    } catch (err) {
      console.error(err);
      toast.error('Failed!');
    }
    setIsQuerying(false);
  };

  const debouncedHandler = useMemo(() => debounce(handleQuery, 1000), []);

  useEffect(() => {
    return () => {
      debouncedHandler.cancel();
    };
  }, []);

  useEffect(() => {
    if (!input) {
      debouncedHandler.cancel();
      setCoachOptions(null);
    } else if (!selectedCoach) {
      debouncedHandler(input);
    }
  }, [input]);

  return (
    <div className='fixed inset-0 bg-black bg-opacity-80 flex'>
      <div className='m-auto w-full max-w-2xl bg-white rounded p-5 relative'>
        <h6 className='text-lg font-medium opacity-80'>Replace Coach</h6>
        <button
          onClick={() => setSelectedAction(null)}
          className='absolute top-4 right-4 opacity-60'
        >
          <Close />
        </button>

        <div className='my-4'>
          <UserDetails user={booking.Coach || {}} compact />
        </div>

        <Autocomplete
          options={coachOptions || []}
          getOptionLabel={(option) => {
            if (typeof option === 'string') return option;
            return `${getFullName(option)} (${option.email}) `;
          }}
          onChange={(_, value) => setSelectedCoach(value || null)}
          value={selectedCoach}
          onInputChange={(_, value) => setInput(value)}
          inputValue={input}
          loading={isQuerying}
          renderInput={(params) => (
            <TextField
              {...params}
              label='Coach'
              variant='outlined'
              placeholder='Search for coaches'
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isQuerying && (
                      <CircularProgress color='inherit' size={20} />
                    )}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />

        <button
          onClick={handleSubmit}
          disabled={isLoading || !selectedCoach}
          className={`bg-blue-c1 text-white rounded w-48 py-1 mt-4 ml-auto flex justify-center ${
            !selectedCoach && 'opacity-50 cursor-not-allowed'
          }`}
        >
          {isLoading ? (
            <CircularProgress color='inherit' size='1.5rem' />
          ) : (
            <span>Confirm</span>
          )}
        </button>
      </div>
    </div>
  );
}
